import No from "../No";

export const getPageMath2WorkingsNotesDemo = (page, edition) => {
  let EditionPageContent;
  let editable = true;
  switch (page) {
    case 1:
      editable = false;
      EditionPageContent = No;
      break;
    default:
      if (page > 1) {
        EditionPageContent = No;
      }
      break;
  }
  return {
    editable,
    component: EditionPageContent,
    addProps: {}
  };
}